import { render } from "./ActualizarClave.vue?vue&type=template&id=a9661512&scoped=true"
import script from "./ActualizarClave.vue?vue&type=script&lang=js"
export * from "./ActualizarClave.vue?vue&type=script&lang=js"

import "./ActualizarClave.vue?vue&type=style&index=0&id=a9661512&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9661512"]])

export default __exports__